var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('crud-editor',{ref:"editor",attrs:{"definition":_vm.definition,"is-edit":false,"auto-generated-id":false,"save":_vm.saveData,"return-to":_vm.returnTo,"item-type":_vm.entity,"get-dependencies":_vm.getDependencies}})}
var staticRenderFns = []

export { render, staticRenderFns }